import { createContext, useContext, useEffect, useState } from "react";
import { ArrowsOut, ArrowsIn } from "@phosphor-icons/react";

const Ctx = createContext(null);

export const PopOut = ({ id, children }) => {
  const [big, setBig] = useState(false);
  useEffect(() => {
    if (!big) return undefined;
    const esc = (e) => {
      if (e.key !== "Escape" || document.querySelector("[data-radix-popper-content-wrapper], [role='dialog'][data-state='open'], [role='alertdialog']")) return;
      setBig(false);
    };
    window.addEventListener("keydown", esc, true);
    document.body.style.overflow = "hidden";
    return () => { window.removeEventListener("keydown", esc, true); document.body.style.overflow = ""; };
  }, [big]);
  return (
    <Ctx.Provider value={{ big, toggle: () => setBig((b) => !b), id }}>
      <div data-testid={`${id}-popout`} data-expanded={big ? "1" : "0"} onClick={(e) => big && e.target === e.currentTarget && setBig(false)}
        className={big ? "fixed inset-0 z-[45] bg-black/80 backdrop-blur-md p-3 md:p-8 overflow-auto animate-in fade-in-0" : ""}>
        <div className={big ? "popout-big mx-auto max-w-[1700px] h-full" : ""}>{children}</div>
      </div>
    </Ctx.Provider>
  );
};

export const PopOutButton = () => {
  const ctx = useContext(Ctx);
  if (!ctx) return null;
  return (
    <button data-testid={`${ctx.id}-popout-btn`} onClick={ctx.toggle} title={ctx.big ? "Close (Esc)" : "Open in a bigger window"} aria-label={ctx.big ? "Close bigger window" : "Open in a bigger window"}
      className="grid h-7 w-7 place-items-center rounded-full border border-[#2A2A2A] text-[#A3A3A3] hover:border-white hover:text-white transition-colors">
      {ctx.big ? <ArrowsIn size={13} /> : <ArrowsOut size={13} />}
    </button>
  );
};
